// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"ba37791f","2580":"ba37791f","8998":"ba37791f"}[chunkId] + ".chunk.css";
};